import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { MatLegacyDialog as MatDialog }from '@angular/material/legacy-dialog';
import { ConfirmDialogComponent, ConfirmDialogData } from 'src/app/shared/confirm-dialog/confirm.dialog.component';
import { LanguageValue } from '@sdbn/common';
import { TranslationService } from '@sdbn/common';
import { ResponseMessage, WidgetStyle } from '@sdbn/appclient';
import { ResponseStatus } from '@sdbn/appclient';
import { DocumentTemplate, DocumentTemplateDetails, SaveDocumentTemplate, TemplateArea, TemplateField } from '../document-template-administration-model';
import { DocumentTemplateAdministrationService } from '../document-template-administration.service';
import { v4 as uuidv4 } from 'uuid';
import { ContextChange } from '@sdbn/appclient';
import { AbstractWidgetComponent } from '@sdbn/appclient';
import { Subscription } from 'rxjs';
import { MasterDetailListEntry } from '@sdbn/common';
import { DocumentTemplateEditorService } from '../document-template-editor.service';
import { DictionaryService } from '@sdbn/appclient';

@Component({
  selector: 'app-document-template-administration',
  templateUrl: './document-template-administration.component.html',
  styleUrls: ['./document-template-administration.component.scss']
})
export class DocumentConfigurationComponent extends AbstractWidgetComponent implements OnDestroy {

  isLoading = false;
  responseMessages: ResponseMessage[];

  templates = new Array<DocumentTemplate>();

  selectedDocumentTemplate: DocumentTemplate;
  // templateDetails: DocumentTemplateDetails = new DocumentTemplateDetails();

  languageSubscription: Subscription;

  editMode = 0;

  // Anzuzeigende Objekte im  Detailsbereich
  selectedTemplate: DocumentTemplateDetails;
  selectedTemplateArea: TemplateArea;


  resizeTemplateFieldLeftEnabled = false;
  resizeTemplateFieldRightEnabled = false;
  selectedTemplateField: TemplateField;

  _template = new DocumentTemplateDetails();

  @Output() saveDetails = new EventEmitter<DocumentTemplateDetails>();
  @Output() cancelEditing = new EventEmitter<DocumentTemplateDetails>();

  @Input() setTemplate(template: DocumentTemplateDetails) {
    this._template = template;

    this.updateAreasIndex();

    for (const area of this._template.areas) {
      this.editorService.updateAreaAfterChanges(area);
    }

    this.showTemplateDetails();
  }

  newItemId = -1;

  //** Drag and Drop fields */
  draggedTemplateField: TemplateField;
  draggedTemplateFieldSourceArea: TemplateArea;
  draggedTemplateArea: TemplateArea;

  showTemplateFieldDropzones = false;

  constructor(
    private dialog: MatDialog,
    private editorService: DocumentTemplateEditorService,
    private templateService: DocumentTemplateAdministrationService,
    public translationService: TranslationService,
    private dictionaryService: DictionaryService
  ) {
    super();
    this.load();

    this.languageSubscription = this.translationService.languageSubject.subscribe(language => {

      this.createTranslatedValuesOnList();

    });
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    if (this.languageSubscription != null) {
      this.languageSubscription.unsubscribe();
    }
  }

  createTranslatedValuesOnList() {
    for (const template of this.templates) {
      template.translatedName = this.translationService.translate(template.nameDictionaryKey);
    }
  }

  public setSelectedDocumentTemplate(documentTemplate: DocumentTemplate) {

    if (this.selectedDocumentTemplate != null && this.selectedDocumentTemplate.id === documentTemplate.id) {
      return;
    }
    const oldSelected = this.selectedDocumentTemplate;
    this.selectedDocumentTemplate = null;

    if (this._template != null && this._template.dirty) {
      const dialogData: ConfirmDialogData = {
        titleKey: 'tmc-yard.widgets.document-template-administration.discard.confirm-dialog.title',
        messageKey: 'tmc-yard.widgets.document-template-administration.discard.confirm-dialog.message',
        confirm: () => {
          this.setSelectedWithoutCheck(documentTemplate);
        },
        cancel: () => {
          this.selectedDocumentTemplate = oldSelected;
        }
      };
      this.dialog.open(ConfirmDialogComponent, {
        data: dialogData
      });
    } else {
      this.setSelectedWithoutCheck(documentTemplate);
    }
  }

  private setSelectedWithoutCheck(documentTemplate: DocumentTemplate) {
    if (documentTemplate != null) {
      this.isLoading = true;
      this.responseMessages = [];
      this.templateService.loadDetails(documentTemplate.id).subscribe(details => {
        this.selectedDocumentTemplate = documentTemplate;
        this.setTemplate(new DocumentTemplateDetails(details));
        this.isLoading = false;
      }, error => {
        this.isLoading = false;
        console.log(error);
      });
    }
  }


  public delete(documentTemplate: DocumentTemplate) {

    this.responseMessages = [];

    const dialogData: ConfirmDialogData = {
      titleKey: 'tmc-yard.widgets.document-template-administration.delete.confirm-dialog.title',
      messageKey: 'tmc-yard.widgets.document-template-administration.delete.confirm-dialog.message',
      confirm: () => {
        this.isLoading = true;
        this.templateService.deleteTemmplate(documentTemplate.id).subscribe(response => {
          if (response.status === ResponseStatus.SUCCESS) {
            this.clearAndLoad();
          } else {
            this.responseMessages = response.responseMessages;
          }
          this.isLoading = false;
        }, error => {
          console.log(error);
          this.isLoading = false;
        });
      }
    };

    this.dialog.open(ConfirmDialogComponent, {
      data: dialogData
    });
  }

  private load() {
    this.isLoading = true;
    this.responseMessages = [];

    this.templateService.loadTemplates().subscribe(
      templates => {
        this.templates = new Array<DocumentTemplate>();
        for (const t of templates) {
          this.templates.push(new DocumentTemplate(t));
        }

        if (this.templates.length > 0) {
          if (this.selectedDocumentTemplate == null) {
            this.setSelectedWithoutCheck(this.templates[0]);
          } else {
            this.setSelectedWithoutCheck(this.templates.find(s => s.id === this.selectedDocumentTemplate.id));
          }
        }

        this.createTranslatedValuesOnList();

        this.isLoading = false;

      }, error => {
        this.templates = new Array<DocumentTemplate>();
        console.error(error);
        this.isLoading = false;
      }
    );
  }

  public addNew() {
    if (this._template != null && this._template.dirty) {
      const dialogData: ConfirmDialogData = {
        titleKey: 'tmc-yard.widgets.document-template-administration.discard.confirm-dialog.title',
        messageKey: 'tmc-yard.widgets.document-template-administration.discard.confirm-dialog.message',
        confirm: () => {
          this.clear();
        }
      };
      this.dialog.open(ConfirmDialogComponent, {
        data: dialogData
      });
    } else {
      this.clear();
    }
  }

  public cancel() {
    // templateDetails: DocumentTemplateDetails
    if (this._template != null && this._template.dirty) {
      const dialogData: ConfirmDialogData = {
        titleKey: 'tmc-yard.widgets.document-template-administration.discard.confirm-dialog.title',
        messageKey: 'tmc-yard.widgets.document-template-administration.discard.confirm-dialog.message',
        confirm: () => {
          this.discardChanges();
        }
      };
      this.dialog.open(ConfirmDialogComponent, {
        data: dialogData
      });
    } else {
      this.discardChanges();
    }
  }

  private discardChanges() {
    this.responseMessages = [];
    if (this._template != null && this._template.dirty) {
      this.setSelectedWithoutCheck(this.selectedDocumentTemplate);
    } else {
      this.setTemplate(this.createNewDocumentTemplate());
      this.selectedDocumentTemplate = null;
    }
  }

  private clear() {
    this.responseMessages = [];
    this.selectedDocumentTemplate = null;
    this.setTemplate(this.createNewDocumentTemplate());
  }

  private createNewDocumentTemplate(): DocumentTemplateDetails {

    const templateDetails = new DocumentTemplateDetails();
    templateDetails.name.values.push(new LanguageValue({language:'de', value:''}));

    const area = new TemplateArea();
    area.uuid = uuidv4();
    area.title.values.push(new LanguageValue({language:'de', value:''}));
    area.help.values.push(new LanguageValue({language:'de', value:''}));
    area.index = 0;
    area.columnCount = 3;

    templateDetails.areas.push(area);

    return templateDetails;
  }

  private clearAndLoad() {
    this.clear();
    this.load();
  }

  // public onSaveDetails(details: DocumentTemplateDetails) {
public save() {

    this.isLoading = true;
    this.responseMessages = [];

    this.templateService.saveDetails(new SaveDocumentTemplate(this._template)).subscribe(response => {
      this.isLoading = false;
      if (response.status === ResponseStatus.SUCCESS) {
        this.dictionaryService.initializeDataDictionary().subscribe(() => {
          this.load();
        });
      } else {
        this.responseMessages = response.responseMessages;
      }
    }, error => {
      console.log(error);
      this.isLoading = false;
    });

  }

  onContextChange(contextChange: ContextChange) {
  }

  onSetElementAndContext() {
  }

  onSelectionChanged(entry: MasterDetailListEntry) {
    this.setSelectedDocumentTemplate(entry as DocumentTemplate);
  }

  onAddEntry(parentPath: Array<MasterDetailListEntry>) {
    this.addNew();
  }

  onDeleteEntry(entry: MasterDetailListEntry) {
    this.delete(entry as DocumentTemplate);
  }





  public onAddTemplateAreaStart(event: DragEvent) {
    event.dataTransfer.effectAllowed = "copy";
    // IOS geht nur wenn gesetzt
    event.dataTransfer.setData("text/plain", "");

    this.draggedTemplateArea = new TemplateArea();
  }

  public onAddTemplateAreaEnd(event: DragEvent) {
    this.draggedTemplateArea = null;
  }

  public onAddTemplateFieldStart(event: DragEvent) {
    event.dataTransfer.effectAllowed = "copy";
    // IOS geht nur wenn gesetzt
    event.dataTransfer.setData("text/plain", "");

    this.showTemplateFieldDropzones = true;
    this.draggedTemplateField = new TemplateField();
  }

  public onAddTemplateFieldEnd(event: DragEvent) {
    this.draggedTemplateField = null;
    this.showTemplateFieldDropzones = false;
  }

  public onDragTemplateFieldStart(event: DragEvent, draggedTemplateField: TemplateField, sourceArea: TemplateArea) {
    event.dataTransfer.effectAllowed = "move";
    // IOS geht nur wenn gesetzt
    event.dataTransfer.setData("text/plain", "");

    this.draggedTemplateField = draggedTemplateField;
    this.draggedTemplateFieldSourceArea = sourceArea;
    this.showTemplateFieldDropzones = true;
  }

  public onDragTemplateFieldEnd(event: DragEvent) {
    this.draggedTemplateField = null;
    this.draggedTemplateFieldSourceArea = null;
    this.showTemplateFieldDropzones = false;
  }

  public onDragTemplateAreaStart(event: DragEvent, area: TemplateArea) {

    event.dataTransfer.effectAllowed = "move";
    // IOS geht nur wenn gesetzt
    event.dataTransfer.setData("text/plain", "");

    this.draggedTemplateArea = area;
  }

  public onDragTemplateAreaEnd(event: DragEvent) {
    this.draggedTemplateArea = null;
  }

  public onDragOverArea(event: DragEvent) {
    // Umsortieren von bestehende Areas
    if (this.draggedTemplateArea != null) {
      event.preventDefault();
      return;
    }
  }

  public onDropBeforeAreas(event: DragEvent) {

    // Hinzufügen einer TemplateArea
    if (this.draggedTemplateArea != null) {

      if (this.draggedTemplateArea.uuid == null) {
        this._template.areas.splice(0, 0, this.createNewArea());
        this._template.dirty = true;
        this.updateAreasIndex();
        this._template.validate();
        this.draggedTemplateArea = null;
        event.preventDefault();
      } else { // Verschieben einer Template Area

        const draggedArea = this._template.areas.find(a => a.uuid === this.draggedTemplateArea.uuid);

        // area entfernen
        const areaIndex = this._template.areas.indexOf(draggedArea);
        this._template.areas.splice(areaIndex, 1);
        // area auf erste postion einfügen
        this._template.areas.splice(0, 0, draggedArea);
        this._template.dirty = true;
        this._template.validate();
        this.draggedTemplateArea = null;
        event.preventDefault();
      }

    }

  }

  public onDropAfterArea(event: DragEvent, sourceArea: TemplateArea) {

    if (this.draggedTemplateArea != null) {

      if (this.draggedTemplateArea != null) {

        // Hinzufügen einer TemplateArea
        if (this.draggedTemplateArea.uuid == null) {
          const index = this._template.areas.indexOf(sourceArea);
          this._template.areas.splice(index + 1, 0, this.createNewArea());
          this._template.dirty = true;
          this.updateAreasIndex();
          this._template.validate();
          this.draggedTemplateArea = null;
          event.preventDefault();
        } else { // Verschieben einer Template Area
          const draggedArea = this._template.areas.find(a => a.uuid === this.draggedTemplateArea.uuid);

          // verschobene area entfernen
          const areaIndex = this._template.areas.indexOf(draggedArea);
          this._template.areas.splice(areaIndex, 1);

          // verschobene area hinter source area einfügen
          const sourceIndex = this._template.areas.findIndex(a => a.uuid === sourceArea.uuid);
          this._template.areas.splice(sourceIndex + 1, 0, draggedArea);
          this._template.dirty = true;
          this._template.validate();
          this.draggedTemplateArea = null;
          event.preventDefault();
        }
      }
    }
  }

  public onDragOverAreaDropzone(event: DragEvent) {

    // Verschieben eines TemplateFields
    if (this.draggedTemplateField != null) {
      event.preventDefault();
      return;
    }

  }

  public onDropToAreaDropzone(event: DragEvent, area: TemplateArea, row: number, column: number, outside: boolean) {

    if (this.draggedTemplateField != null) {

      // Hinzufügen einer TemplateField
      if (this.draggedTemplateField.uuid == null) {
        const templateField = new TemplateField();
        templateField.uuid = uuidv4();
        templateField.colSpan = 1;

        if (outside === true) {
          area.fields.forEach(f => {
            if (f.row >= row) {
              f.row = f.row + 1;
            }
          });
          templateField.row = row;
          templateField.column = column;
        } else {
          templateField.row = row;
          templateField.column = column;
        }

        area.fields.push(templateField);

        this.editorService.updateAreaAfterChanges(area);

        this.showTemplateFieldDetails(area, templateField);

        this._template.dirty = true;
        this._template.validate();

        this.draggedTemplateField = null;
        this.draggedTemplateFieldSourceArea = null;

        this.showTemplateFieldDetails(area, templateField);

        event.preventDefault();
        return;
      }

      // wenn das feld in eine anderen Area verschoben wurde
      if (this.draggedTemplateFieldSourceArea !== area) {

        // Feld aus source area entfernen
        this.draggedTemplateFieldSourceArea.fields.splice(this.draggedTemplateFieldSourceArea.fields.indexOf(this.draggedTemplateField), 1);

        // und in zielarea einfügen
        area.fields.push(this.draggedTemplateField);

        if (outside === true) {

          area.fields.forEach(f => {
            if (f.row >= row) {
              f.row = f.row + 1;
            }
          });

          this.draggedTemplateField.colSpan = 1;
          this.draggedTemplateField.row = row;
          this.draggedTemplateField.column = column;
          this._template.dirty = true;
        } else {
          this.draggedTemplateField.colSpan = 1;
          this.draggedTemplateField.row = row;
          this.draggedTemplateField.column = column;
          this._template.dirty = true;
        }

        this.editorService.updateAreaAfterChanges(area);
        this._template.validate();
        this.showTemplateFieldDetails(area, this.draggedTemplateField);
      } else {
        // Verschieben eines TemplateFields
        if (outside === true) {

          area.fields.forEach(f => {
            if (f.row >= row) {
              f.row = f.row + 1;
            }
          });

          this.draggedTemplateField.colSpan = 1;
          this.draggedTemplateField.row = row;
          this.draggedTemplateField.column = column;
          this._template.dirty = true;
        } else {
          this.draggedTemplateField.colSpan = 1;
          this.draggedTemplateField.row = row;
          this.draggedTemplateField.column = column;
          this._template.dirty = true;
        }
        this.editorService.updateAreaAfterChanges(area);
        this._template.validate();
        this.showTemplateFieldDetails(area, this.draggedTemplateField);
      }

      this.draggedTemplateField = null;
      this.draggedTemplateFieldSourceArea = null;

      event.preventDefault();
      return;
    }
  }

  public counter(count: number): Array<any> {
    return new Array(count);
  }

  public showTemplateDetails() {
    this.selectedTemplate = this._template;
    this.selectedTemplateArea = null;
    this.resizeTemplateFieldLeftEnabled = false;
    this.resizeTemplateFieldRightEnabled = false;
    this.selectedTemplateField = null;
  }

  public showTemplateAreaDetails(area: TemplateArea) {
    this.selectedTemplate = null;
    this.selectedTemplateArea = area;
    this.resizeTemplateFieldLeftEnabled = false;
    this.resizeTemplateFieldRightEnabled = false;
    this.selectedTemplateField = null;
  }

  public showTemplateFieldDetails(area: TemplateArea, field: TemplateField) {
    this.selectedTemplate = null;
    this.selectedTemplateArea = null;
    this.resizeTemplateFieldLeftEnabled = false;
    this.resizeTemplateFieldRightEnabled = false;
    this.selectedTemplateField = field;
    this.updateTemplateFieldResizeButtonVisibility(area, field);
  }

  private updateTemplateFieldResizeButtonVisibility(area: TemplateArea, field: TemplateField) {
    // freie zellen zu area
    // matrix spalten * zeilen mit false befüllen
    // für jedes field
    // zweidimensionales array anhand row/colum + span mit true befüllen
    const freeDropzones: any[][] = [[], []];

    for (let row = 1; row <= area.rowCount; row++) {

      freeDropzones[row] = [];

      for (let column = 1; column <= area.columnCount; column++) {
        freeDropzones[row][column] = true;
      }
    }

    for (const f of area.fields) {
      for (let colSpanOffset = 0; colSpanOffset < f.colSpan; colSpanOffset++) {
        freeDropzones[f.row][f.column + colSpanOffset] = false;
      }
    }

    if (area.columnCount > 1) {
      this.resizeTemplateFieldLeftEnabled = freeDropzones[field.row][field.column - 1] === true;

      const rightColumnIndex = field.column + field.colSpan;
      this.resizeTemplateFieldRightEnabled = freeDropzones[field.row][rightColumnIndex] === true;
    }
  }

  public onDeleteTemplateArea(area: TemplateArea) {
    const dialogData: ConfirmDialogData = {
      titleKey: 'tmc-yard.widgets.template-editor.delete-area.confirm-dialog.title',
      messageKey: 'tmc-yard.widgets.template-editor.delete-area.confirm-dialog.message',
      confirm: () => {
        const index = this._template.areas.findIndex(a => a.uuid === area.uuid);
        this._template.areas.splice(index, 1);
        this._template.dirty = true;
        this._template.validate();
        this.showTemplateDetails();
      }
    };

    this.dialog.open(ConfirmDialogComponent, {
      data: dialogData
    });
  }

  public onDeleteTemplateField(field: TemplateField) {
    const dialogData: ConfirmDialogData = {
      titleKey: 'tmc-yard.widgets.template-editor.delete-field.confirm-dialog.title',
      messageKey: 'tmc-yard.widgets.template-editor.delete-field.confirm-dialog.message',
      confirm: () => {

        let parent = null;
        let fieldIndex = null;

        this._template.areas.forEach(area => {
          const tmpIndexOfField = area.fields.findIndex(f => f.uuid === field.uuid)
          if (tmpIndexOfField !== -1) {
            parent = area;
            fieldIndex = tmpIndexOfField;
            return;
          }
        });

        if (parent != null) {
          parent.fields.splice(fieldIndex, 1);
          this._template.dirty = true;
          this.editorService.updateAreaAfterChanges(parent);
          this._template.validate();
          this.showTemplateAreaDetails(parent);
        }
      }
    };

    this.dialog.open(ConfirmDialogComponent, {
      data: dialogData
    });
  }

  public count(count: number) {
    const array = new Array<number>();
    for (let i = 1; i <= count; i++) {
      array.push(i);
    }

    return array;
  }

  private createNewArea(): TemplateArea {
    const area = new TemplateArea();
    area.uuid = uuidv4();
    area.style = '';
    area.columnCount = 3;

    this.editorService.updateAreaAfterChanges(area);

    return area;
  }

  private updateAreasIndex() {
    let index = 0;
    for (const area of this._template.areas) {
      area.index = index++;
    }
  }

  public editStructure() {
    this.editMode = 0;
  }

  public editProperties() {
    this.editMode = 1;
  }

  public increaseTemplateFieldSizeToLeft(area: TemplateArea, field: TemplateField) {
    field.column = field.column - 1;
    field.colSpan = field.colSpan + 1;
    this.editorService.updateAreaAfterChanges(area);
    this.updateTemplateFieldResizeButtonVisibility(area, field);
    this._template.dirty = true;
    this._template.validate();
  }

  public decreaseTemplateFieldSizeToLeft(area: TemplateArea, field: TemplateField) {
    field.colSpan = field.colSpan - 1;
    this.editorService.updateAreaAfterChanges(area);
    this.updateTemplateFieldResizeButtonVisibility(area, field);
    this._template.dirty = true;
    this._template.validate();
  }

  public increaseTemplateFieldSizeToRight(area: TemplateArea, field: TemplateField) {
    field.colSpan = field.colSpan + 1;
    this.editorService.updateAreaAfterChanges(area);
    this.updateTemplateFieldResizeButtonVisibility(area, field);
    this._template.dirty = true;
    this._template.validate();
  }

  public decreaseTemplateFieldSizeToRight(area: TemplateArea, field: TemplateField) {
    field.colSpan = field.colSpan - 1;
    field.column = field.column + 1;
    this.editorService.updateAreaAfterChanges(area);
    this.updateTemplateFieldResizeButtonVisibility(area, field);
    this._template.dirty = true;
    this._template.validate();
  }

  getStyle(): WidgetStyle {
    return WidgetStyle.transparent;
  }

}
